import gql from "graphql-tag";

export const GET_ACTIVE_DEALS = gql`
  query active_deals(
    $business_profile_id: uuid
    $club_profile_id: uuid
    $current_date_time: timestamp
    $limit: Int
    $search_text: String
    $order_by: [deals_order_by!] = {}
  ) {
    deals(
      where: {
        _or: [
          { business_profile_id: { _eq: $business_profile_id } }
          { club_profile_id: { _eq: $club_profile_id } }
        ]
        expire_date_time: { _gte: $current_date_time }
        manually_end_at: { _is_null: true }
        name: { _ilike: $search_text }
      }
      limit: $limit
      order_by: $order_by
    ) {
      id
      name
      description
      condition
      created_at
      updated_at
      expire_date_time
      type
      image_path
      image_url
      views_count
      deals_claimeds_aggregate {
        aggregate {
          count
        }
      }
    }
  }
`;
